module.exports = __webpack_public_path__ + "img/fist_ios_802.png";